import { computed, watch } from 'vue';
import { defineStore } from 'pinia';
import { useHipSpineStore } from '@/views/3d-planner/hipSpine/hipSpineStore';
import { createEditState, type EditContext } from '@/views/3d-planner/hipSpine/xrayEdit/editState';
import { createEditResolution } from '@/views/3d-planner/hipSpine/xrayEdit/editDerived';
import { createEditActions } from '@/views/3d-planner/hipSpine/xrayEdit/editActions';

export const useHipSpineXRayEditViewModel = defineStore('hip-spine-xray-edit', () => {
    const store = useHipSpineStore();
    const state = createEditState();
    const ctx: EditContext = { store, ...state };

    // Reset edits when the active case or study changes
    watch(
        () => [store.caseId, store.studyId],
        () => {
            state.editsByPosture.clear();
            state.lumbarLevelByPosture.clear();
            state.viewedSideByPosture.clear();
            state.hiddenGroupKeysByPosture.clear();
            state.dragState.value = { kind: 'idle' };
            state.hover.value = { kind: 'none' };
            state.loupe.value = { active: false };
        },
    );

    const isEditMode = computed(() => store.activePanelView === 'annotations');
    const hasEditsForActivePosture = computed(() => {
        const id = store.activePostureId;
        const edits = id ? state.editsByPosture.get(id) : undefined;
        if (!edits) return false;
        return (
            Object.keys(edits.landmarks).length > 0 ||
            edits.femurRadius[1] !== undefined ||
            edits.femurRadius[2] !== undefined
        );
    });

    return {
        editsByPosture: state.editsByPosture,
        dragState: state.dragState,
        hover: state.hover,
        loupe: state.loupe,
        isEditMode,
        hasEditsForActivePosture,
        ...createEditResolution(ctx),
        ...createEditActions(ctx),
    };
});
